export default {
  password: {
    min: 6,
    max: 50,
  },
  type: {
    admin: 'admin',
    store: 'store',
  },
};
